const ORPHANS = /(^|[\s(\u00A0])([iwzoua])[^\S\u00A0]+/gi;

/**
 * Polska typografia: jednoliterowe spójniki (i, w, z, o, u, a) nie mogą
 * kończyć wiersza — doklejamy je twardą spacją do następnego słowa.
 * Zwykłe spacje po spójniku są wykluczone z klasy [^\S\u00A0], więc już
 * wstawione twarde spacje działają jako lewy ogranicznik i pętla domyka
 * łańcuchy sąsiadujących spójników ("i w", "a o").
 */
export function pl(text: string): string {
  let previous;
  let out = text;
  do {
    previous = out;
    out = out.replace(ORPHANS, "$1$2\u00A0");
  } while (out !== previous);
  return out;
}
